import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface SystemFunction {
  id: string;
  name: string;
  code: string;
  route: string;
  icon?: string;
  categoryId?: string;
  menuOrder: number;
  isActive: boolean;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateFunctionDto {
  name: string;
  code: string;
  route: string;
  icon?: string;
  categoryId?: string;
  menuOrder: number;
  isActive?: boolean;
  description?: string;
}

export interface UpdateFunctionDto {
  name?: string;
  code?: string;
  route?: string;
  icon?: string;
  categoryId?: string;
  menuOrder?: number;
  isActive?: boolean;
  description?: string;
}

export const functionsApi = {
  // Get all functions
  async getAllFunctions(): Promise<SystemFunction[]> {
    const response = await api.get('/functions');
    return response.data;
  },

  // Get function by ID
  async getFunctionById(id: string): Promise<SystemFunction> {
    const response = await api.get(`/functions/${id}`);
    return response.data;
  },

  // Create new function
  async createFunction(data: CreateFunctionDto): Promise<SystemFunction> {
    const response = await api.post('/functions', data);
    return response.data;
  },

  // Update function
  async updateFunction(id: string, data: UpdateFunctionDto): Promise<SystemFunction> {
    const response = await api.patch(`/functions/${id}`, data);
    return response.data;
  },

  // Toggle function status
  async toggleFunctionStatus(id: string): Promise<SystemFunction> {
    const response = await api.patch(`/functions/${id}/toggle`);
    return response.data;
  },

  // Delete function
  async deleteFunction(id: string): Promise<void> {
    await api.delete(`/functions/${id}`);
  },

  // Seed default functions
  async seedDefaultFunctions(): Promise<{ message: string }> {
    const response = await api.get('/functions/seed');
    return response.data;
  },
}; 